const _data = [
  {
    batchOrderNo: 'PC1790256724214263810',
    orderNos:
      'ZC1790256724214263810,ZC1790256724214263810,ZC1790256724214263810,ZC1790256724214263810,ZC1790256724214263810,ZC1790256724214263810,ZC1790256724214263810,ZC1790256724214263810,ZC1790256724214263810,ZC1790256724214263810'
  },
  {
    batchOrderNo: 'PC1790256724214263810',
    orderNos: 'ZC1790256724214263810,ZC1790256724214263810'
  }
];

const _getData = (data, key) => {
  return data.reduce((a, b) => {
    if (!a) {
      a += b[key];
    } else {
      a += ',' + b[key];
    }
    return a;
  }, '');
};

export const createMsgbox = (self, resData, cb) => {
  const res = resData.request !== undefined ? resData.data : resData;

  if (+res.code !== 2) return false;

  // eslint-disable-next-line no-unused-vars
  const h = self.$createElement;
  const data = res.data || [];

  try {
    self
      .$msgbox({
        title: '提示',
        message: (
          <div style="box-sizing: border-box; padding: 0 30px; text-align: left; max-height: 500px; overflow-y: auto;  word-break: none !important;">
            {data.map(item => {
              const batchOrderNoArr = item.batchOrderNo.split(',');
              const orderNosArr = item.orderNos.split(',');

              return (
                <div style="margin-bottom: 10px">
                  <div style="display: flex">
                    <span style="font-weight: 600">批次：</span>
                    <p style="flex: 1;">
                      {batchOrderNoArr.map(val => {
                        return (
                          <span style="word-break: normal !important;">
                            【{val}】
                          </span>
                        );
                      })}
                    </p>
                  </div>
                  <div style="margin-left: 30px; display: flex">
                    <span style="font-weight: 600">订单：</span>
                    <p style="flex: 1;">
                      {orderNosArr.map(val => {
                        return (
                          <span style="word-break: normal !important;">
                            【{val}】
                          </span>
                        );
                      })}
                    </p>
                  </div>
                </div>
              );
            })}
            <span style="margin-top: 20px; color: red">
              订单异常无法支付，请修改后重新生成订单。
            </span>
          </div>
        ),
        center: true,
        showCancelButton: false,
        closeOnClickModal: false,
        confirmButtonText: '我知道了',
        customClass: 'checkMessage'
      })
      .then(action => {
        if (cb && typeof cb === 'function')
          cb({
            orderNos: _getData(data, 'orderNos'),
            batchOrderNo: _getData(data, 'batchOrderNo'),
            data,
            type: action
          });
      })
      .catch(error => {
        if (cb && typeof cb === 'function')
          cb({
            orderNos: _getData(data, 'orderNos'),
            batchOrderNos: _getData(data, 'batchOrderNo'),
            data,
            type: error
          });
      });
  } catch (error) {
    console.log(error);
  }

  return true;
};
